module.exports = __webpack_public_path__ + "img/reservation.2469d698.svg";